import React from 'react'

import { twMerge } from 'tailwind-merge'

interface SectionTitleProps {
  title?: string
  children?: React.ReactNode
  className?: string
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  children,
  className,
}) =>
  children || title ? (
    <h2
      className={twMerge(
        'font-sora text-[32px] text-balance leading-[36px] md:text-[38px] md:leading-[46px]',
        className,
      )}
    >
      {children || title}
    </h2>
  ) : null

export default SectionTitle
